var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 11.6667H9M3.66667 11.6667C2.78844 11.6667 2.32711 11.6551 1.97067 11.4729C1.63607 11.3022 1.36412 11.0299 1.19378 10.6951C1 10.3156 1 9.81778 1 8.82222V3.84444C1 2.84889 1 2.35111 1.19378 1.97067C1.36444 1.63556 1.63556 1.36444 1.97067 1.19378C2.35111 1 2.84889 1 3.84444 1H14.1556C15.1511 1 15.6489 1 16.0284 1.19378C16.3636 1.36444 16.6356 1.63556 16.8062 1.97067C17 2.35022 17 2.848 17 3.84178V8.82489C17 9.81867 17 10.3156 16.8062 10.6951C16.6356 11.03 16.3633 11.3022 16.0284 11.4729C15.6489 11.6667 15.152 11.6667 14.1582 11.6667H9M3.66667 11.6667C3.66667 10.6844 4.86044 9.88889 6.33333 9.88889C7.80622 9.88889 9 10.6844 9 11.6667M14.3333 8.11111H10.7778M14.3333 5.44444H11.6667M6.33333 7.22222C5.86184 7.22222 5.40965 7.03492 5.07625 6.70152C4.74286 6.36812 4.55556 5.91594 4.55556 5.44444C4.55556 4.97295 4.74286 4.52076 5.07625 4.18737C5.40965 3.85397 5.86184 3.66667 6.33333 3.66667C6.80483 3.66667 7.25701 3.85397 7.59041 4.18737C7.92381 4.52076 8.11111 4.97295 8.11111 5.44444C8.11111 5.91594 7.92381 6.36812 7.59041 6.70152C7.25701 7.03492 6.80483 7.22222 6.33333 7.22222Z",
    stroke: "#D2D6DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.9fdee472cdd2208c3e601eeb298cb5ac.svg";
export { ForwardRef as ReactComponent };